module.exports = __webpack_public_path__ + "../static/img/router.209f6d18.png";